import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import CompanyService from 'services/company2';
import CustFieldService from 'services/custField';
import * as MobileActions from 'actions/index.ts';
import Util from 'lib/util.js';
const formatBig = Util.formatBig;
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import User from 'services/user2';
import ModalService from 'services/modal';
import Http from 'services/http2';
import CommonFns from 'functions/common.ts';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import DeliveryItemsUpdate from 'components/deliveryItemsUpdate';
import DeliveryFns from 'functions/delivery.ts';
import EditIcon from '@material-ui/icons/Edit';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ReceiveService from 'services/receive.ts';
import DeliveryToReceive from 'components/deliveryToReceive.js';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import BodyCustField from 'components/bodyCustField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import Enum from 'services/enum2';
import { withStyles } from '@material-ui/core/styles';
import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Big from 'big.js';

const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  },
  marginNormal: {
    marginTop: '0px'
  },
  input: {
    padding: '10px 20px'
  }
});
const isEmpty = Util.isEmpty;
/**
 * 送货单详情
 *
 *
 */
function DeliveryDetail(props) {
  const Config = {
    sale: {
      apiPath: '/deliveryNotice/getDetail',
      enumMainKey: 'B02_Dn_Status',
      companyNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        },
        {
          mainKey: 'B02_Dn_Logistics_Status',
          subKey: 'logisticsStatus',
          value: 'logisticsStatusName'
        },
        {
          mainKey: 'B02_Dn_Type',
          subKey: 'deliveryType',
          value: 'deliveryTypeName'
        },
        {
          mainKey: 'B02_Dn_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'dnXkNo'
    },
    purchase: {
      apiPath: '/vdeliveryNotice/getDetail',
      enumMainKey: 'B02_Dn_Status',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Purchase_Type',
          subKey: 'purchaseType',
          value: 'purchaseTypeName'
        },
        {
          mainKey: 'B02_Dn_Logistics_Status',
          subKey: 'logisticsStatus',
          value: 'logisticsStatusName'
        },
        {
          mainKey: 'B02_Dn_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Send_Verify_Status',
          subKey: 'sendVerifyStatus',
          value: 'sendVerifyStatusName'
        }
      ],
      idField: 'dnXkNo',
      wfmCode: '1034'
    }
  };

  const styles1 = {
    editIcon: {
      position: 'absolute',
      right: '15px',
      color: '#666'
    }
  };
  const dateReg =
    /^(?:(?!0000)[0-9]{4}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-8])|(?:0[13-9]|1[0-2])-(?:29|30)|(?:0[13578]|1[02])-31)|(?:[0-9]{2}(?:0[48]|[2468][048]|[13579][26])|(?:0[48]|[2468][048]|[13579][26])00)-02-29)$/; //校验YYYY-MM-DD，是否合法

  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    forceUpdate,
    detail,
    setDetail,
    workflow,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [fieldSetting, setFieldSetting] = useState({});
  const [lineList, setLineList] = useState([]);
  const [currItem, setCurrItem] = useState({
    deliveryQty: '',
    deliveryValuationQty: '',
    remark: ''
  });
  const [operateType, setOperateType] = useState(1);
  const [isReceiving, setIsReceiving] = useState(false);
  const [checkOpenReceAddressFlag, setCheckOpenReceAddressFlag] =
    useState(false);
  const [isGodown, setIsGodown] = useState(false);
  const [billType, setBillType] = useState(null);
  const [actType, setActType] = useState('');
  const [logisticsEdit, setLogisticsEdit] = useState(false);
  const [compEnumCustomer, setCompEnumCustomer] = useState([]);
  const [compEnum, setCompEnum] = useState([]);
  const [innerAddressList, setInnerAddressList] = useState([]);
  const [expressCompanyList, setExpressCompanyList] = useState([]);
  const [isRequireLogistics, setisRequireLogistics] = useState([]);
  const [ruleVersionList, setRuleVersionList] = useState([]);
  const [isSetBarcode, setIsSetBarcode] = useState(false);
  const [isArrived, setisArrived] = useState(false);
  const [canGodown, setCanGodown] = useState(false);
  const [showVerifyStatus, setShowVerifyStatus] = useState(true);
  const [arrDiff, setArrDiff] = useState([]); //出货异常，未出货，收货差异
  const [btnState, setBtnState] = useState({
    confirmReceive: true, //确认收货
    newReceive: true, //转收货
    newStorage: true, //转入库
    goodsArrived: true, //货物送达
    return: true //退回
  }); //按钮状态

  const [deliveryQtySum, setDeliveryQtySum] = useState(0);
  const [deliveryValQtySum, setDeliveryValQtySum] = useState(0);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);
  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  useEffect(() => {
    detail.deliveryCarNo = detail.deliveryCarNo || '';
    detail.contactPersion = detail.contactPersion || '';
    detail.contactMobile = detail.contactMobile || '';
    detail.addressInfo = detail.addressInfo || '';
    detail.receiveContactPerson = detail.receiveContactPerson || '';
    detail.receiveContactWay = detail.receiveContactWay || '';
    detail.logisticsNumber = detail.logisticsNumber || '';
    detail.planArrivedDateShow =
      formatDate(detail.planArrivedDate, 'YYYY-MM-DDTHH:mm') || '';
    detail.deliveryDateShow =
      formatDate(detail.deliveryDate, 'YYYY-MM-DD') || '';
  }, [detail]);

  self.afterGetDetail = function (data) {
    let list = data.lineList || [];
    setLineList(DeliveryFns.parseLineList(list));
    let currList = DeliveryFns.parseLineList(list) || [];
    setArrDiff(DeliveryFns.figureDiff(currList)); //出货异常，未出货，收货差异数量

    // 检查是否开启送货地址
    ReceiveService.checkOpenReceAddress(data.customerCode).then(flag => {
      setCheckOpenReceAddressFlag(flag);
    });

    //获取企业参数-是否启用平台收货流程
    CompanyService.getCompanyParamsByCodes(
      [companyCode],
      [
        'Use_platform_recieve_process',
        'Use_platform_verify_process',
        'Use_recieve_order_down_erp',
        'Inspection_by_delivey'
      ],
      true
    ).then(res => {
      let companyParams = {};
      res.forEach(row => {
        companyParams[row.paramCode] =
          row.paramType === 1 ? row.paramValue : row.paramValue === '1';
      });
      let recieveProcess = companyParams['Use_platform_recieve_process'];
      let verifyProcess = companyParams['Use_platform_verify_process'];
      let recieveDownErp = companyParams['Use_recieve_order_down_erp'];
      let inspectDelivey = companyParams['Inspection_by_delivey'];

      // 启用平台收货流程，且下传ERP是收货单，可收货
      if (
        recieveProcess &&
        recieveDownErp === '1' &&
        data.directWarehousingFlag !== 1
      ) {
        setIsReceiving(true);
        setBillType(2);
      }

      // 启用平台收货流程，下传ERP是入库单、且未开启来料检验，可入库
      if (
        recieveProcess &&
        (recieveDownErp === '2' ||
          (recieveDownErp === '1' && data.directWarehousingFlag === 1))
      ) {
        setIsGodown(true);
        setBillType(3);
      }

      /*
       * 是否展示检验相关字段。启用平台收货流程，下传ERP是收货单、且开启来料检验,不展示检验相关字段
       */
      setShowVerifyStatus(
        !(recieveProcess && recieveDownErp === '1' && verifyProcess)
      );

      /*
       * 未启用平台收货流程，送货单可转检验
       * 启用平台收货流程，下传ERP是入库单，送货单可转检验
       * 启用平台收货流程，下传ERP是收货单、且未开启来料检验，送货单可转检验
       * 启用平台来料检验流程，送货单状态是已完成，屏蔽 新建检验单
       */
      data.canRreateIqcOrder =
        !recieveProcess ||
        (recieveProcess &&
          ((recieveDownErp === '1' && !verifyProcess) ||
            recieveDownErp === '2') &&
          !(data.status === 3 && verifyProcess));
      /*
       * 启用 检验发起必须在货物送达状态,物流状态=已到货,送货单可转检验
       */
      data.inspectDelivey =
        !inspectDelivey || (inspectDelivey && data.logisticsStatus === 2);

      list.forEach(item => {
        if (
          recieveProcess &&
          recieveDownErp === '2' &&
          verifyProcess &&
          Util.isBig(
            item.totAllowQty,
            item.totCompromiseQty,
            item.convertReceiveQty
          ) &&
          !Big(item.totAllowQty)
            .plus(item.totCompromiseQty)
            .minus(item.convertReceiveQty)
            .gt(0)
        ) {
          item.canGodown = false;
        } else {
          item.canGodown = true;
        }

        Enum.getValue('B02_Send_Verify_Status', item.sendVerifyStatus).then(
          value => {
            item.sendVerifyStatusName = value;
            forceUpdate();
          }
        );
      });
      if (!self.isPurchase) {
        checkDeliveryValuationQty(list, data);
      }
      let cangodown = list.some(item => item.canGodown === true) ? true : false;
      setCanGodown(cangodown);
    });

    if (!self.isPurchase) {
      //获取企业参数-是否启用平台收货流程
      CompanyService.getCompanyParamsByCodes(
        [data.customerCode],
        [
          'Delivery_Need_Plan_Arrived_Date_Flag',
          'Delivery_Logistics_Info_Check'
        ],
        true
      ).then(res => {
        let companyParams = {};
        res.forEach(row => {
          companyParams[row.paramCode] =
            row.paramType === 1 ? row.paramValue : row.paramValue === '1';
        });
        let planArrived = companyParams['Delivery_Need_Plan_Arrived_Date_Flag'];
        let RequireLogistics =
          companyParams['Delivery_Logistics_Info_Check'] &&
          data.deliveryType !== 2 &&
          (data.deliveryApplyFlag !== 1 || data.status === 7);
        setisArrived(planArrived);
        setisRequireLogistics(RequireLogistics);
      });

      getExpressCompanyList();
    }

    //预设值
    ['extendN01Value', 'extendN02Value', 'extendN03Value'].forEach(key => {
      let o = Util.jsonDecode(data[key]);
      if (Array.isArray(o)) {
        if (typeof o[0] === 'string') {
          data[key] = (o || []).map(value => {
            return {
              id: value,
              text: value
            };
          });
        } else {
          data[key] = o;
        }
      }
    });
    //按钮显示条件
    initBtns(data);
    getRuleDetail(data);
    getFieldSetting(data);
    getTransportType(data);
    getInnerAddressList(data);
    getCustomerDetail(data);
    getLogisticsType();
    setDetail(data);

    getLineQtySum(list);
  };

  //获取自定义字段设置
  function getFieldSetting(data) {
    let customerCode;
    if (!self.isPurchase) {
      customerCode = data.customerCode;
    }
    //获取自定义字段
    CustFieldService.getSetting(
      companyCode,
      customerCode,
      true,
      22,
      dispatch
    ).then(rs => {
      if (rs) {
        let fieldData = rs;
        if (Array.isArray(fieldData.list)) {
          fieldData.list.forEach(item => {
            //单头单身日期字段，转换为时间戳
            CustFieldService.parseCustFields(
              fieldData,
              data,
              data.lineList,
              self.isPurchase
            );
          });
        }
        setFieldSetting(fieldData);

        let arr = DeliveryFns.parseLineList(data.lineList);
        let cCode = self.isPurchase ? companyCode : data.customerCode;
        // 计算送货单单身显示字段是否开启，是否必填
        CustFieldService.checkBodyNormalFieldOpen(cCode, arr, fieldData).then(
          () => {
            setLineList(arr);
          }
        );
      }
    });
  }

  function getLineQtySum(list) {
    let deliQtySum = Big(0);
    let deliValQtySum = Big(0); // 计价数量
    list.forEach(item => {
      deliQtySum = deliQtySum.plus(formatBig(item.deliveryQty));
      deliValQtySum = deliValQtySum.plus(formatBig(item.deliveryValuationQty));
    });
    setDeliveryQtySum(deliQtySum.valueOf());
    setDeliveryValQtySum(deliValQtySum.valueOf());
  }

  // 获取快递公司列表
  function getExpressCompanyList() {
    Enum.getList('B2b_KuaiDi_CompanyNames').then(rs => {
      if (Array.isArray(rs)) {
        let arr = rs.map(item => {
          return { id: item.subKey, text: item.subValue };
        });
        setExpressCompanyList(arr);
      }
    });
  }

  //修改送货数量
  function handleEdit(item, type) {
    setCurrItem(item);
    setOperateType(type);
    const { actions } = props;
    actions.openQtyReviseModal();
  }

  //获取钮权限
  function getButtonAuth(code) {
    return CommonFns.getButtonAuth(
      'delivery',
      code,
      User,
      detail,
      self.isPurchase
    );
  }

  //检查是否有转收货/入库的权限
  function checkDnStatus(data) {
    let errorMsg;
    let billTypeName = {
      2: '收货单',
      3: '入库单'
    };
    let text = billTypeName[billType];
    if (data.id === undefined) {
      errorMsg = '无送货单信息';
    } else if (data.deliveryType === 2) {
      errorMsg = '补送货单不能转' + text;
    } else if (data.convertStatus === 2) {
      errorMsg = '此送货单已转' + text;
    } else if (![1, 2].includes(data.status)) {
      errorMsg = '送货单状态不是待签收或签收中';
    } else if ([1, 2].includes(data.multiRelationRoleType)) {
      errorMsg = '多角送货单无法转' + text;
    }
    if (errorMsg) {
      ModalService.showError(errorMsg, dispatch);
    } else {
      const { actions } = props;
      actions.openStockInModal();
    }
  }

  //获取物料是否能维护计价数量的权限
  async function checkValuationQty(customerCode, productCodes) {
    let postbody = {
      companyCode: companyCode,
      customerCode,
      productCodes,
      apiPath: '/archives/customizeCategory/checkValuationQtyFlag'
    };
    let res = {};
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        res = response.data;
      }
    });
    return res;
  }

  async function checkDeliveryValuationQty(list, detailData) {
    if (self.isPurchase) {
      return;
    }
    let lineListArr = list || [];
    await checkValuationQty(
      detailData.customerCode,
      lineListArr.map(item => item.productCode)
    ).then(res => {
      for (const key in res) {
        if (Object.prototype.hasOwnProperty.call(res, key)) {
          lineListArr
            .filter(item => item.productCode === key)
            .forEach(item => {
              item.isEditDeliveryValuationQty = res[key] === 1 ? true : false;
            });
        }
      }
    });
  }

  function changeDelivery() {
    if (!canGodown && billType !== 2) {
      ModalService.showError('没有可转入库量', dispatch);
      return;
    }
    checkDnStatus(detail);
  }

  function handleOrder(type) {
    const dnXkNo = detail.dnXkNo;

    switch (type) {
      case 'publish': //发布发货通知
        if (!validateRule()) {
          return;
        }
        if (!validateLogistics()) {
          return;
        }
        if (!validatePlanArrivedDate()) {
          return;
        }
        // if (!validateFieldData()) {
        //   return;
        // }

        handleConfirm(dnXkNo, '/deliveryNotice/publish', '确认发出送货通知？');
        break;
      case 'publish2': //申请批准后，发布送货单
        if (!validateRule()) {
          return;
        }
        if (!validateLogistics()) {
          return;
        }
        if (!validatePlanArrivedDate()) {
          return;
        }
        handleConfirm(
          dnXkNo,
          '/deliveryNotice/agreeApplyPublish',
          '确认发出送货通知？'
        );
        break;
      case 'received': //货物送达
        handleConfirm(
          dnXkNo,
          '/vdeliveryNotice/recieveLogistics',
          '确认货物已送达？'
        );
        break;
      case 'sendout': //货物发出
        handleConfirm(
          dnXkNo,
          '/deliveryNotice/sendLogistics',
          '确认货物已发出？'
        );
        break;
      case 'commit': //申请货物发出
        if (!validateRule()) {
          return;
        }
        handleConfirm(
          dnXkNo,
          '/deliveryNotice/commitApply',
          '确认发出送货申请？'
        );
        break;
      case 'agree': //批准货物发出
        handleConfirm(
          dnXkNo,
          '/vdeliveryNotice/agreeApply',
          '确认批准供应商送货申请？'
        );
        break;
      case 'delete': //删除
        handleConfirm(
          dnXkNo,
          '/deliveryNotice/delete',
          '确认删除送货通知草稿？'
        );
        break;
      case 'return1':
        handleRetrun(dnXkNo, '/vdeliveryNotice/backApply');
        break;
      case 'return2':
        handleRetrun(dnXkNo, '/vdeliveryNotice/back');
        break;
      case 'cancel1': //签收撤回
        handleRecall(dnXkNo, '/deliveryNotice/revoke');
        break;
      case 'cancel2': //申请撤回
        handleRecall(dnXkNo, '/deliveryNotice/revokeApply');
        break;
      case 'abandon': //作废
        handleConfirm(
          dnXkNo,
          '/deliveryNotice/abandon',
          '确认作废送货通知单？'
        );
        break;
      case 'handlePublish': //确认收货
        handlePublish();
        break;
      default:
    }
  }

  function handle(type) {
    handleOrder(type);
    setActType(type);
  }

  //发布发货通知
  function handleConfirm(dnXkNo, apiPath, dialogMsg) {
    let postbody = {
      companyCode: companyCode,
      dnXkNo,
      apiPath: apiPath
    };
    ReceiveService.deliveryConfirm(
      postbody,
      dialogMsg,
      () => {
        if (actType === 'delete') {
          setRedirect('/mp/sale/delivery/list');
        } else {
          self.getDetail();
        }
      },
      dispatch
    );
  }

  //退回
  function handleRetrun(dnXkNo, apiPath) {
    let postbody = {
      companyCode: companyCode,
      dnXkNo,
      apiPath: apiPath
    };
    ReceiveService.deliveryRuturn(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  // 拒绝申请退回
  function rejectApply() {
    let postbody = {
      companyCode: companyCode,
      dnXkNo: detail.dnXkNo,
      apiPath: '/vdeliveryNotice/refuseApplyReturn'
    };
    ReceiveService.rejectApply(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //撤回
  function handleRecall(dnXkNo, apiPath) {
    let postbody = {
      companyCode: companyCode,
      dnXkNo,
      apiPath: apiPath
    };
    ReceiveService.deliveryRecall(
      postbody,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //转收货/入库完成
  function handleConvertChange(data) {
    if (Array.isArray(data)) {
      ModalService.showTip('操作成功', dispatch);
      setTimeout(() => {
        if (data.length > 1) {
          // self.getDetail();
          setRedirect('/mp/purchase/receive/list');
        } else if (data[0]) {
          let url =
            billType === 2
              ? '/mp/purchase/receive/detail/'
              : '/mp/purchase/storage/detail/';
          setRedirect(url + companyCode + '/' + data[0]);
        }
      }, 2000);
    }
  }

  //确认核销
  function handlePublish() {
    let ok = () => {
      let postbody = {
        dnXkNos: [self.id],
        companyCode: companyCode,
        vendorXkUniqueCode: detail.vendorXkUniqueCode,
        apiPath: '/vdeliveryNotice/manualRelate/publish'
      };
      Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          ModalService.showTip('发送成功', dispatch);
          self.getDetail();
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };
    let diffStatusName = detail.diffStatus === 0 ? '无差异' : '有差异';
    let info = '签收' + `『${diffStatusName}』`;
    //优先提示未签收项
    if (arrDiff[1] > 0) {
      info = '『' + arrDiff[1] + '项未签收' + '』';
    }
    ModalService.showConfirm(
      '供应商送货签收' + info + '，' + '是否确认结果并发送给供应商？',
      ok,
      dispatch
    );
  }

  //编辑物流信息
  function handleLogisticsEdit() {
    setLogisticsEdit(true);
  }

  function getTransportType(data) {
    let arr = [];
    CompanyService.getCompEnumList(
      data.customerCode,
      'B2b_Transport_Type_Code'
    ).then(res => {
      arr['B2b_Transport_Type_Code'] = res.map(item => {
        return { id: item.subKey, text: item.subValue };
      });
    });
    setCompEnumCustomer(arr);
  }

  function getLogisticsType() {
    let arr = [];
    Enum.getList('B02_Logistics_Type').then(list => {
      arr['B02_Logistics_Type'] = list
        .filter(item => item.subKey !== '4')
        .map(item => {
          return {
            id: item.subKey,
            text: item.subValue
          };
        });
    });
    setCompEnum(arr);
  }

  //获取送货地址列表(企业资料中维护的地址)
  function getInnerAddressList(data) {
    if (!data.customerCode) {
      return;
    }
    let postbody = {
      companyCode: data.customerCode,
      profitCenterCode: data.profitCenterCode,
      storeCode: data.storeCode,
      apiPath: '/archives/inner/delivery/address/getList'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let arr = [];
        arr = response.data.map(item => {
          let address =
            (item.provinceName || '') +
            (item.cityName || '') +
            (item.districtName || '') +
            item.detailedAddress;
          return {
            id: item.deliveryPlaceCode,
            text: address,
            contactPerson: item.contactPerson,
            contactWay: item.contactWay
          };
        });
        setInnerAddressList(arr);
        //当送货地址为1个时， 自动填充送货地址
        if (arr.length === 1) {
          data.addressCode = arr[0].id;
          data.addressInfo = arr[0].text;
          data.receiveContactPerson = arr[0].contactPerson;
          data.receiveContactWay = arr[0].contactWay;
        }
      }
    });
  }

  function handleSelectChange(event, key) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    if (key === 'logisticsType') {
      val = parseInt(event.target.value, 10);
    }
    if (key === 'transportTypeCode') {
      detailObj.transportTypeName = compEnumCustomer[
        'B2b_Transport_Type_Code'
      ].filter(item => item.id === event.target.value)[0].text;
    }
    if (key === 'addressCode') {
      detailObj.addressInfo =
        innerAddressList.filter(item => item.id === event.target.value)[0]
          ?.addressInfo || '';
      detailObj.receiveContactPerson =
        innerAddressList.filter(item => item.id === event.target.value)[0]
          ?.contactPerson || '';
      detailObj.receiveContactWay =
        innerAddressList.filter(item => item.id === event.target.value)[0]
          ?.contactWay || '';
    }
    if (key === 'expressCompanyCode') {
      detailObj.expressCompanyName = expressCompanyList.filter(
        item => item.id === val
      )[0]?.text;
    }
    detailObj[key] = val;
    setDetail(detailObj);
  }

  function updateOrderHeader(detailObj) {
    let postbody = {
      companyCode: companyCode,
      extendN01: detailObj.extendN01,
      extendN02: detailObj.extendN02,
      extendN03: detailObj.extendN03,
      dnXkNo: self.id,
      apiPath: '/deliveryNotice/updateOrderHeader'
    };
    if (self.isPurchase) {
      postbody.apiPath = '/vdeliveryNotice/updateCustomInfo';
    }
    setShowLoading(true);
    Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  function handleFieldSelectChange(event, key) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    detailObj[key] = val;

    updateOrderHeader(detailObj);
    setDetail(detailObj);
  }

  function handleFieldInputChange(event, key, type) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    if (type === 0) {
      val = Util.qtyChange(event.target.value);
    }
    detailObj[key] = val;
    updateOrderHeader(detailObj);
    setDetail(detailObj);
  }

  // 自定义时间变更
  function handleFieldDateChange(event, key) {
    let detailObj = Util.clone(detail);
    if (event.target.value) {
      detailObj[key] = event.target.valueAsNumber - 28800000;
      detailObj[key] = formatDate(detailObj[key], 'YYYY-MM-DD') || '';
      detailObj[key + 'Date'] = detailObj[key];
    }
    updateOrderHeader(detailObj);
    setDetail(detailObj);
  }

  function handleChange(event, key) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    detailObj[key] = val;
    setDetail(detailObj);
  }

  function handleBlur(event, key) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    setDetail(detailObj);
  }

  function handleClose() {
    setLogisticsEdit(false);
  }

  // 保存物流信息
  function handleOk() {
    if (!validateLogistics()) {
      return;
    }
    let postbody = {
      companyCode: companyCode,
      logisticsType: detail.logisticsType,
      transportTypeCode: detail.transportTypeCode,
      transportTypeName: detail.transportTypeName,
      deliveryCarNo: detail.deliveryCarNo,
      contactPersion: detail.contactPersion,
      contactMobile: detail.contactMobile,
      addressCode: detail.addressCode,
      addressInfo: detail.addressInfo,
      receiveContactPerson: detail.receiveContactPerson,
      receiveContactWay: detail.receiveContactWay,
      logisticsNumber: detail.logisticsNumber,
      expressCompanyCode: detail.expressCompanyCode,
      expressCompanyName: detail.expressCompanyName,
      dnXkNo: self.id,
      apiPath: '/deliveryNotice/updateOrderHeader'
    };
    setShowLoading(true);
    Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        self.getDetail();
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
      handleClose();
    });
  }

  //校验物流字段
  function validateLogistics() {
    let rs = true;
    if (isRequireLogistics) {
      if (!detail.logisticsType) {
        //送货方式不能为空
        ModalService.showError('送货方式不能为空', dispatch);
        return false;
      }
      if (
        !isEmpty(compEnumCustomer['B2b_Transport_Type_Code']) &&
        !detail.transportTypeCode
      ) {
        //运输方式不能为空
        ModalService.showError('运输方式不能为空', dispatch);
        return false;
      }
      if (
        !detail.deliveryCarNo &&
        (detail.logisticsType === 1 || detail.logisticsType === 5)
      ) {
        //送货车牌不能为空
        ModalService.showError('送货车牌不能为空', dispatch);
        return false;
      }
      if (
        (!detail.contactPersion || !detail.contactMobile) &&
        (detail.logisticsType === 1 || detail.logisticsType === 5)
      ) {
        //送货联络不能为空
        ModalService.showError('送货联络不能为空', dispatch);
        return false;
      }
      if (!detail.logisticsNumber && detail.logisticsType === 2) {
        //物流单号不能为空
        ModalService.showError('物流单号不能为空', dispatch);
        return false;
      }
    }

    /**
     * 送货地址不能为空
     *
     * 1.是否限定按直运看板送货 === 否
     * 2.送货列表不为空 或 开启送货地址参数
     */
    if (
      ((!detail['addressCode'] && !isEmpty(innerAddressList)) ||
        (checkOpenReceAddressFlag && isEmpty(detail.addressInfo))) &&
      detail['directDeliveryFlag'] !== 1
    ) {
      ModalService.showError('送货地址不能为空', dispatch);
      return false;
    }

    return rs;
  }

  function handleRuleSelectChange(event, key) {
    let detailObj = Util.clone(detail);
    let val = event.target.value;
    if (key === 'ruleVersionCode') {
      detailObj.ruleVersionName =
        ruleVersionList.filter(item => item.id === event.target.value)[0]
          ?.text || '';
    }
    detailObj[key] = val;

    let postbody = {
      companyCode: companyCode,
      ruleVersionCode: detailObj.ruleVersionCode,
      ruleVersionName: detailObj.ruleVersionName,
      dnXkNo: self.id,
      apiPath: '/deliveryNotice/updateOrderHeader'
    };
    setShowLoading(true);
    Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
    setDetail(detailObj);
  }

  function handlePlanArrivedDateChange(event) {
    let detailObj = Util.clone(detail);
    if (event.target.value) {
      detailObj.planArrivedDate = event.target.valueAsNumber - 28800000;
      detailObj.planArrivedDateShow =
        formatDate(detailObj.planArrivedDate, 'YYYY-MM-DDTHH:mm') || '';
    }
    let postbody = {
      companyCode: companyCode,
      planArrivedDate: detailObj.planArrivedDate,
      dnXkNo: self.id,
      apiPath: '/deliveryNotice/updateOrderHeader'
    };
    setShowLoading(true);
    Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
    setDetail(detailObj);
  }

  function handledeliveryDateChange(event) {
    let detailObj = Util.clone(detail);
    if (event.target.value) {
      detailObj.deliveryDate = event.target.valueAsNumber - 28800000;
      detailObj.deliveryDateShow =
        formatDate(detailObj.deliveryDate, 'YYYY-MM-DD') || '';
    }
    let postbody = {
      companyCode: companyCode,
      deliveryDate: detailObj.deliveryDate,
      dnXkNo: self.id,
      apiPath: '/deliveryNotice/updateOrderHeader'
    };
    setShowLoading(true);
    Http.post('/api/cloudCenter', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
    setDetail(detailObj);
  }

  //已有的条码规则
  function getRuleDetail(data) {
    data.ruleSettingType = '1'; //客户设置条码规则方式。1. 按供应商，2. 按物料分类。
    let arr = CompanyService.getCompanyParamsByCodes(
      data.customerCode,
      ['Delivery_Bar_Code_Rule_Settings'],
      true
    );
    if (Array.isArray(arr)) {
      data.ruleSettingType = arr[0]?.paramValue || '1';
    }

    //只有【未发送，撤回，退回】才可以重新修改送货单，需要重新获取条码规则列表
    if (data.status && ![0, 4, 6].includes(data.status)) {
      return;
    }

    if (data.ruleSettingType === '2') {
      data['ruleVersionCode'] = undefined;
      data['ruleVersionName'] = undefined;
      setRuleVersionList([]);
      return;
    }

    CompanyService.getCustomerRuleList(data.customerXkUniqueCode).then(res => {
      let list = res.map(item => {
        return { id: item.ruleVersionCode, text: item.ruleVersionName };
      });
      setRuleVersionList(list);
    });
  }

  function getCustomerDetail(data) {
    CompanyService.getCustomerDetail(
      companyCode,
      data.customerXkUniqueCode
    ).then(rs => {
      setIsSetBarcode(rs?.barcodeDeliveryRulesFlag === 1); //送货条码标识：0:不启用 1:启用
    });
  }

  function validateRule() {
    let rs = true;
    if (isSetBarcode && !isEmpty(ruleVersionList)) {
      if (!detail.ruleVersionCode) {
        //条码版本不能为空
        ModalService.showError('条码版本不能为空', dispatch);
        return false;
      }
    }
    return rs;
  }

  function validatePlanArrivedDate() {
    let rs = true;
    //预计到厂日不能为空
    if (isArrived && isEmpty(detail.planArrivedDate)) {
      ModalService.showError('预计到厂时间不能为空', dispatch);
      return false;
    }

    //预计到厂时间不能小于送货日期
    if (
      detail.planArrivedDate &&
      detail.planArrivedDate < detail.deliveryDate
    ) {
      ModalService.showError('预计到厂时间不能小于送货日期', dispatch);
      return false;
    }
    return rs;
  }

  /**
   * 供应商端校验自定义字段
   *
   * @param detail 单据详情数据
   * @param lineList 单身数据
   * @param billType 单据类型：22.送货单
   *
   * @returns
   */
  function validateFieldData() {
    if (
      !CustFieldService.validate(
        detail,
        lineList,
        fieldSetting,
        false,
        dispatch
      )
    ) {
      return false;
    }
    return true;
  }

  //新建来料检验单 sourceOrderType  1来源送货单 2来源收货单 3入库单(api传)
  function createIqcOrder() {
    let postbody = {
      sourceXkNo: detail.dnXkNo,
      companyCode: detail.companyCode,
      sourceOrderType: 1,
      apiPath: '/verify/order/create'
    };
    ReceiveService.createIqcOrder(
      postbody,
      response => {
        let data = response;
        if (!Util.isEmpty(data)) {
          self.getDetail();
          setTimeout(() => {
            if (data.length === 1) {
              setRedirect(
                '/mp/purchase/iqc/detail/' + companyCode + '/' + data[0]
              );
            } else {
              setRedirect('/mp/purchase/iqc/list');
            }
          }, 500);
        }
      },
      dispatch
    );
  }

  //初始化按钮显示条件
  function initBtns(data) {
    //代签送货单
    if (data.isSignForSupplier === 1) {
      btnState.goodsArrived = false;
      btnState.newReceive = false;
      btnState.newStorage = false;
      btnState.return = false;
      //待签收状态时
      if (data.status === 1) {
        btnState.confirmReceive = false;
      }
      setBtnState(btnState);
    }
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.id && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">采购方</span>
                      <div className="field-value">
                        {detail.multiRelationRoleType === 1
                          ? detail.multiCompanyName
                          : detail.companyName}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">
                      {self.isPurchase ? '供应商' : '客户'}
                    </span>
                    <div className="field-value">
                      {self.isPurchase
                        ? detail.innerVendorName +
                          '(' +
                          detail.innerVendorCode +
                          ')'
                        : detail.innerCustomerName +
                          '(' +
                          detail.innerCustomerCode +
                          ')'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">送货日期</span>
                    <div className="field-value">
                      {[0, 4, 6, 11].includes(detail.status) &&
                      !self.isPurchase ? (
                        <React.Fragment>
                          <form noValidate>
                            <TextField
                              value={detail.deliveryDateShow || ''}
                              onChange={e => handledeliveryDateChange(e)}
                              id="date"
                              type="date"
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                          </form>
                        </React.Fragment>
                      ) : (
                        <div>
                          {formatDate(detail.deliveryDate, 'YYYY-MM-DD')}
                        </div>
                      )}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">条码版本</span>
                    <div className="field-value">
                      {self.isPurchase && <span>{detail.ruleVersionName}</span>}
                      {!self.isPurchase && (
                        <React.Fragment>
                          {![0, 4, 6].includes(detail.status) ||
                          Util.isEmpty(ruleVersionList) ? (
                            <span>{detail.ruleVersionName}</span>
                          ) : (
                            <div>
                              {ruleVersionList && (
                                <FormControl
                                  variant="outlined"
                                  margin="normal"
                                  fullWidth
                                  classes={{
                                    marginNormal: props.classes.marginNormal
                                  }}
                                >
                                  <Select
                                    value={detail.ruleVersionCode}
                                    onChange={e =>
                                      handleRuleSelectChange(
                                        e,
                                        'ruleVersionCode'
                                      )
                                    }
                                    input={
                                      <OutlinedInput
                                        labelWidth={0}
                                        classes={{
                                          input: props.classes.input
                                        }}
                                        name="formTypeCode"
                                        id="outlined-formTypeCode-simple"
                                      />
                                    }
                                  >
                                    {ruleVersionList.map((item, index) => (
                                      <MenuItem key={index} value={item.id}>
                                        {item.text}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              )}
                            </div>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">预计到厂</span>
                    <div className="field-value">
                      {[0, 4, 6, 11].includes(detail.status) &&
                      !self.isPurchase ? (
                        <React.Fragment>
                          <form noValidate>
                            <TextField
                              value={detail.planArrivedDateShow || ''}
                              onChange={e => handlePlanArrivedDateChange(e)}
                              id="datetime-local"
                              type="datetime-local"
                              InputLabelProps={{
                                shrink: true
                              }}
                              style={{ width: '90%', float: 'right' }}
                            />
                          </form>
                        </React.Fragment>
                      ) : (
                        <div>
                          {formatDate(
                            detail.planArrivedDate,
                            'YYYY-MM-DD HH:mm'
                          )}
                        </div>
                      )}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">送货状态</span>
                    <div>
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Dn_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>
                  {/* 审批流状态 仅开启后才显示 */}
                  {self.isPurchase && updateTs > 0 && workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                        />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && updateTs > 0 && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                  {detail.status === 6 && (
                    <li>
                      <span className="field-label">退回原因</span>
                      <div className="field-value">{detail.backReason}</div>
                    </li>
                  )}
                  {[4, 11].includes(detail.status) && (
                    <li>
                      <span className="field-label">撤回原因</span>
                      <div className="field-value">{detail.backReason}</div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">物流状态</span>
                    <div
                      className={
                        [2].indexOf(detail.logisticsStatus) > -1
                          ? 'order-detail-value green'
                          : 'order-detail-value blue'
                      }
                    >
                      {detail.logisticsStatusName}
                    </div>
                  </li>
                  {self.isPurchase && showVerifyStatus && (
                    <li>
                      <span className="field-label">送检状态</span>
                      <div
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'sendVerify',
                            detail.sendVerifyStatus
                          )
                        }
                      >
                        {detail.sendVerifyStatusName}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">送货单号</span>
                    <div className="field-value">{detail.dnXkNo}</div>
                  </li>
                  {self.isPurchase ? (
                    ''
                  ) : (
                    <li>
                      <span className="field-label">内部单号</span>
                      <div className="field-value">{detail.dnInnerNo}</div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">送货类型</span>
                    <div className="field-value">{detail.deliveryTypeName}</div>
                  </li>
                  <li>
                    <span className="field-label">采购类型</span>
                    <div className="field-value">{detail.purchaseTypeName}</div>
                  </li>
                  {detail.purchaseType === 3 && (
                    <li>
                      <span className="field-label">收货企业</span>
                      <div className="field-value">
                        {!self.isPurchase
                          ? detail.receiveCustomerInnerName
                          : detail.multiRelationRoleType === 1
                            ? detail.companyName
                            : detail.multiCompanyName}
                      </div>
                    </li>
                  )}
                  {!self.isPurchase && detail.profitCenterCode && (
                    <li>
                      <span className="field-label">收货部门</span>
                      <div className="field-value">
                        {detail.profitCenterName}
                      </div>
                    </li>
                  )}
                  {((self.isPurchase && detail.status !== 1) ||
                    (!self.isPurchase && ![0, 4, 6].includes(detail.status))) &&
                    fieldSetting.headCustList &&
                    fieldSetting.headCustList.map((item, index) => (
                      <li key={item.id}>
                        <span className="field-label">{item.transName}</span>
                        <div className="field-value">
                          {detail[item.fieldCode]}
                        </div>
                      </li>
                    ))}

                  {((self.isPurchase && detail.status === 1) ||
                    (!self.isPurchase && [0, 4, 6].includes(detail.status))) &&
                    fieldSetting.headCustList &&
                    fieldSetting.headCustList.map((item, index) => (
                      <li key={item.id}>
                        <span className="field-label">{item.transName}</span>
                        {((self.isPurchase &&
                          item.needVendorInputFlag === 0 &&
                          User.checkAuth('10030109')) ||
                          (!self.isPurchase &&
                            item.needVendorInputFlag === 1)) && (
                          <div className="field-value">
                            {item.fieldValueType === 0 && (
                              <input
                                type="text"
                                className="fieldInputClass"
                                value={detail[item.fieldCode] || ''}
                                onChange={e =>
                                  handleFieldInputChange(e, item.fieldCode, 0)
                                }
                              />
                            )}
                            {item.fieldValueType === 1 && (
                              <input
                                type="text"
                                className="fieldInputClass"
                                value={detail[item.fieldCode] || ''}
                                onChange={e =>
                                  handleFieldInputChange(e, item.fieldCode, 1)
                                }
                              />
                            )}
                            {item.fieldValueType === 2 && (
                              <FormControl
                                classes={{
                                  marginNormal: props.classes.marginNormal
                                }}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                              >
                                <Select
                                  value={detail[item.fieldCode] || ''}
                                  onChange={e =>
                                    handleFieldSelectChange(e, item.fieldCode)
                                  }
                                  input={
                                    <OutlinedInput
                                      labelWidth={0}
                                      classes={{
                                        input: props.classes.input
                                      }}
                                      name="formTypeCode"
                                      id="outlined-formTypeCode-simple"
                                    />
                                  }
                                >
                                  {item.presetValueList &&
                                    item.presetValueList.map((row, i) => (
                                      <MenuItem
                                        key={String(row.id) + i}
                                        value={row.id}
                                      >
                                        {row.text}
                                      </MenuItem>
                                    ))}
                                </Select>
                              </FormControl>
                            )}
                            {item.fieldValueType === 3 && (
                              <React.Fragment>
                                <form noValidate>
                                  <TextField
                                    value={detail[item.fieldCode] || ''}
                                    onChange={e =>
                                      handleFieldDateChange(e, item.fieldCode)
                                    }
                                    id="head-filed-date"
                                    type="date"
                                    InputLabelProps={{
                                      shrink: true
                                    }}
                                    style={{ width: '90%', float: 'right' }}
                                  />
                                </form>
                              </React.Fragment>
                            )}
                          </div>
                        )}

                        {!(
                          (self.isPurchase &&
                            item.needVendorInputFlag === 0 &&
                            User.checkAuth('10030109')) ||
                          (!self.isPurchase && item.needVendorInputFlag === 1)
                        ) && (
                          <div className="field-value">
                            {detail[item.fieldCode]}
                          </div>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>物流信息{logisticsEdit}</label>
              {!self.isPurchase &&
                [0, 1, 7, 4, 6].includes(detail.status) &&
                detail.logisticsStatus !== 2 &&
                detail.directDeliveryFlag !== 1 && (
                  <div className="more">
                    <i
                      className="icon-edit"
                      onClick={() => {
                        handleLogisticsEdit();
                      }}
                    ></i>
                  </div>
                )}
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">送货方式</span>
                    <div className="field-value">
                      {detail.logisticsTypeShow}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">
                      {detail.logisticsType === 3 ? '自提地址' : '送货地址'}
                    </span>
                    <div className="field-value">{detail.addressInfo}</div>
                  </li>

                  {detail.logisticsType === 2 && (
                    <li>
                      <span className="field-label">快递公司</span>
                      <div className="field-value">
                        {detail.expressCompanyName}
                      </div>
                    </li>
                  )}

                  <li>
                    <span className="field-label">运输方式</span>
                    <div className="field-value">
                      {detail.transportTypeName}
                    </div>
                  </li>
                  {detail.logisticsType === 2 && (
                    <li>
                      <span className="field-label">物流单号</span>
                      <div className="field-value">
                        {detail.logisticsNumber}
                      </div>
                    </li>
                  )}
                  {[1, 5].includes(detail.logisticsType) && (
                    <li>
                      <span className="field-label">送货联络</span>
                      <div className="field-value">
                        {detail.contactPersion} {detail.contactMobile}
                      </div>
                    </li>
                  )}
                  {[1, 5].includes(detail.logisticsType) && (
                    <li>
                      <span className="field-label">送货车牌</span>
                      <div className="field-value">{detail.deliveryCarNo}</div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">联系方式</span>
                    <div className="field-value">
                      {detail.receiveContactPerson} {detail.receiveContactWay}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">送货备注</span>
                    <div className="field-value">{detail.remark}</div>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div
            className={moreSign2 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(2);
            }}
          >
            {moreSign2 && '更多'}
            {!moreSign2 && '收起'}
            <i className="icon-down"></i>
          </div> */}
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>产品明细</label>
              <span className="more">
                实际送货总数：
                {formatNumber(deliveryQtySum, decimalPlace.QTY)}
              </span>
              <span className="more">
                实际计价总数：
                {formatNumber(deliveryValQtySum, decimalPlace.QTY)}
              </span>
              <span className="more">
                订单金额：
                {formatNumber(detail.totalAmount, decimalPlace.AMOUNT)}
              </span>
            </div>
            <div className="details-item-content">
              {!Util.isEmpty(lineList) &&
                lineList.map((line, index) => (
                  <div
                    className="content-line line-list-item"
                    key={String(line[0].id) + index}
                  >
                    <div className="line-list-item-title">
                      <span>项次{line[0].lineNo}</span>
                      {((!self.isPurchase &&
                        User.checkAuth('20030102') &&
                        line.isSingle &&
                        [0, 4, 6].includes(detail.status)) ||
                        (self.isPurchase &&
                          false &&
                          User.checkAuth('10030105') &&
                          line.isSingle &&
                          [1, 5].includes(detail.status))) && (
                        <div className="more">
                          <i
                            className="icon-edit"
                            onClick={() => {
                              handleEdit(line[0], 1);
                            }}
                          ></i>
                          <i
                            className="icon-delete"
                            onClick={() => {
                              handleEdit(line[0], 2);
                            }}
                          ></i>
                        </div>
                      )}
                    </div>

                    <ul className="field-list">
                      <li>
                        <span className="field-label">产品编码</span>
                        <div className="field-value">{line[0].productCode}</div>
                      </li>
                      <li>
                        <span className="field-label">产品名称</span>
                        <div className="field-value">{line[0].productName}</div>
                      </li>
                      <li>
                        <span className="field-label">产品规格</span>
                        <div className="field-value">
                          {line[0].productScale}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">客户单号(项次)</span>
                        <div className="field-value">
                          {line[0].poErpNo}({line[0].poLineNo})
                        </div>
                      </li>
                      <li>
                        <span className="field-label">送货类型</span>
                        <div className="field-value">
                          {line[0].billTypeName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">订单交期</span>
                        <div className="field-value">
                          {formatDate(line[0].expectedDate)}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">
                          {self.isPurchase ? '订单应出数量' : '订单待交数量'}
                        </span>
                        <div className="field-value">
                          {' '}
                          {formatNumber(
                            line[0].billType === 1
                              ? line[0].totalWaitDeliveryQty
                              : line.waitDeliveryQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </div>
                      </li>
                      {line.isSingle && (
                        <li>
                          <span className="field-label">排定交期</span>
                          <div className="field-value">
                            {formatDate(line[0].deliveryDate)}
                          </div>
                        </li>
                      )}
                      {line.isSingle && (
                        <li>
                          <span className="field-label">
                            {self.isPurchase ? '排定应出数量' : '排定待交数量'}
                          </span>
                          <div className="field-value">
                            {formatNumber(
                              line[0].waitDeliveryQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                          </div>
                        </li>
                      )}
                      {detail.deliveryApplyFlag === 1 && (
                        <li>
                          <span className="field-label">申请数量</span>
                          <div className="field-value">
                            <span>
                              {formatNumber(
                                line.applyDeliveryQty,
                                decimalPlace.Quantity_Decimal_Place
                              )}
                              {line[0].deliveryUnitName}
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">实际送货数量</span>
                        <div className="field-value">
                          <span
                            className={
                              line.waitDeliveryQty !== line.deliveryQty
                                ? 'red'
                                : ''
                            }
                          >
                            {formatNumber(
                              line.deliveryQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                            {line[0].deliveryUnitName}
                          </span>
                        </div>
                      </li>
                      {detail.deliveryApplyFlag === 1 && (
                        <li>
                          <span className="field-label">申请计价数量</span>
                          <div className="field-value">
                            <span>
                              {formatNumber(
                                line.applyDeliveryValuationQty,
                                decimalPlace.Quantity_Decimal_Place
                              )}
                              {line[0].valuationUnitName}
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">计价数量</span>
                        <div className="field-value">
                          {' '}
                          <span>
                            {formatNumber(
                              line.deliveryValuationQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                            {line[0].valuationUnitName}
                          </span>
                        </div>
                      </li>
                      {(() => {
                        if (detail.status !== 0) {
                          return [
                            <li key={line[0].id + 1}>
                              <span className="field-label">收货数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  line.receiveQty,
                                  decimalPlace.Quantity_Decimal_Place
                                )}
                              </div>
                            </li>,
                            <li key="2">
                              <span className="field-label">入库数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  line.storageQty,
                                  decimalPlace.Quantity_Decimal_Place
                                )}
                              </div>
                            </li>,
                            <li key="3">
                              <span className="field-label">退货数量</span>
                              <div className="field-value">
                                {formatNumber(
                                  line.returnQty,
                                  decimalPlace.Quantity_Decimal_Place
                                )}
                              </div>
                            </li>
                          ];
                        }
                      })()}
                      {self.isPurchase && showVerifyStatus && (
                        <li>
                          <span className="field-label">送检状态</span>
                          <div className="field-value">
                            <span
                              className={
                                'u-sign ' +
                                CommonFns.getStatusClass(
                                  'sendVerify',
                                  line[0].sendVerifyStatus
                                )
                              }
                            >
                              {line[0].sendVerifyStatusName}
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <span className="field-label">备注</span>
                        <div className="field-value">{line[0].remark}</div>
                      </li>
                      <li>
                        <span className="field-label">订单备注</span>
                        <div className="field-value">
                          {line[0].srcOrderLineRemark}
                        </div>
                      </li>
                      {line[0].poLine &&
                        line[0].poLine.printExtendFields !== '' && (
                          <li>
                            <span className="field-label">采购说明</span>
                            <div className="field-value">
                              {line[0].poLine.printExtendFields}
                            </div>
                          </li>
                        )}

                      {/* 单身显示字段 */}
                      {fieldSetting.bodyNormalList &&
                        fieldSetting.bodyNormalList.map((item, i) => (
                          <li key={String(item.id) + i}>
                            <span className="field-label">
                              {item.fieldName}
                            </span>
                            <div className="field-value">
                              {line[0][item.fieldCode] || '--'}
                            </div>
                          </li>
                        ))}
                    </ul>
                    {/* 单身自定义字段 */}
                    {line[0].dnLineExtend && (
                      <BodyCustField
                        fieldSetting={fieldSetting}
                        line={line[0].dnLineExtend}
                      ></BodyCustField>
                    )}

                    {line.isSingle ? (
                      ''
                    ) : (
                      <div className="order-detail-more">
                        {!line.isSingle &&
                          line.map((item, i) => (
                            <ul
                              key={'sub' + item.id + i}
                              className="field-list bc-wathet"
                            >
                              {((!self.isPurchase &&
                                User.checkAuth('20030102') &&
                                !line.isSingle &&
                                [0, 4, 6].includes(detail.status)) ||
                                (self.isPurchase &&
                                  User.checkAuth('10030105') &&
                                  !line.isSingle &&
                                  [5].includes(detail.status))) && (
                                <div className="order-detail-item">
                                  <span
                                    className="icons bc-wathet"
                                    style={{ top: '5px' }}
                                  >
                                    <EditIcon
                                      className="edit"
                                      onClick={() => handleEdit(line[i], 1)}
                                    />
                                    {!self.isPurchase && (
                                      <HighlightOffIcon
                                        className="delete"
                                        onClick={() => handleEdit(line[i], 2)}
                                      />
                                    )}
                                  </span>
                                </div>
                              )}
                              <li>
                                <span className="field-label">
                                  排定待交数量
                                </span>
                                <div className="field-value">
                                  {formatNumber(
                                    item.waitDeliveryQty,
                                    decimalPlace.Quantity_Decimal_Place
                                  )}
                                  {item.deliveryUnitName}
                                </div>
                              </li>
                              <li>
                                <span className="field-label">排定交期</span>
                                <div className="field-value">
                                  {formatDate(item.deliveryDate)}
                                </div>
                              </li>
                              {detail.deliveryApplyFlag === 1 && (
                                <li>
                                  <span className="field-label">申请数量</span>
                                  <div className="field-value">
                                    <span>
                                      {formatNumber(
                                        item.applyDeliveryQty,
                                        decimalPlace.Quantity_Decimal_Place
                                      )}
                                      {item.deliveryUnitName}
                                    </span>
                                  </div>
                                </li>
                              )}
                              <li>
                                <span className="field-label">
                                  实际送货数量
                                </span>
                                <div className="field-value">
                                  <span
                                    className={
                                      item.waitDeliveryQty !== item.deliveryQty
                                        ? 'red'
                                        : ''
                                    }
                                  >
                                    {formatNumber(
                                      item.deliveryQty,
                                      decimalPlace.Quantity_Decimal_Place
                                    )}
                                    {item.deliveryUnitName}
                                  </span>
                                </div>
                              </li>
                              {detail.deliveryApplyFlag === 1 && (
                                <li>
                                  <span className="field-label">
                                    申请计价数量
                                  </span>
                                  <div className="field-value">
                                    <span>
                                      {formatNumber(
                                        item.applyDeliveryValuationQty,
                                        decimalPlace.Quantity_Decimal_Place
                                      )}
                                      {item.valuationUnitName}
                                    </span>
                                  </div>
                                </li>
                              )}
                              <li>
                                <span className="field-label">计价数量</span>
                                <div className="field-value">
                                  <span>
                                    {formatNumber(
                                      item.deliveryValuationQty,
                                      decimalPlace.Quantity_Decimal_Place
                                    )}
                                    {item.valuationUnitName}
                                  </span>
                                </div>
                              </li>
                            </ul>
                          ))}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
      <div className="wrap m-flex-box fixed-bottom">
        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [0, 4, 6].includes(detail.status) &&
          (detail.deliveryApplyFlag === 0 || detail.deliveryType === 2) && (
            <Button
              type="default"
              onClick={() => {
                handle('publish');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认发出
            </Button>
          )}
        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [7, 9].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handle('publish2');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认发出
            </Button>
          )}
        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [0].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handle('delete');
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              删除
            </Button>
          )}

        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [4, 6].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handle('abandon');
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              作废
            </Button>
          )}
        {!self.isPurchase &&
        User.checkAuth('20030105') &&
        detail.status === 1 &&
        detail.logisticsStatus === 0 ? (
          <Button
            type="default"
            onClick={() => {
              handle('sendout');
            }}
            className="m-flex-item u-btn u-btn_primary"
          >
            货物发出
          </Button>
        ) : (
          ''
        )}
        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [0, 4, 6].includes(detail.status) &&
          detail.deliveryApplyFlag === 1 && (
            <Button
              type="default"
              onClick={() => {
                handle('commit');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              申请送货
            </Button>
          )}

        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [1].includes(detail.status) &&
          detail.logisticsStatus === 0 && (
            <Button
              type="default"
              onClick={() => {
                handle('cancel1');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              撤回
            </Button>
          )}
        {!self.isPurchase &&
          User.checkAuth('20030102') &&
          [5].includes(detail.status) &&
          detail.logisticsStatus === 0 && (
            <Button
              type="default"
              onClick={() => {
                handle('cancel2');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              撤回
            </Button>
          )}

        {self.isPurchase &&
        User.checkAuth('10030106') &&
        [1, 2].includes(detail.status) &&
        detail.logisticsStatus !== 2 &&
        detail.multiRelationRoleType !== 2 &&
        btnState.goodsArrived ? (
          <Button
            type="default"
            onClick={() => {
              handle('received');
            }}
            className="m-flex-item u-btn u-btn_primary"
          >
            货物送达
          </Button>
        ) : (
          ''
        )}
        {self.isPurchase &&
        User.checkAuth('10030102') &&
        [1, 2].includes(detail.status) &&
        detail.multiRelationRoleType !== 1 &&
        btnState.confirmReceive ? (
          <Button
            type="default"
            onClick={() => {
              handle('handlePublish');
            }}
            className="m-flex-item u-btn u-btn_primary"
          >
            手动签收完成
          </Button>
        ) : (
          ''
        )}
        {self.isPurchase &&
          User.checkAuth('10030105') &&
          detail.status === 5 &&
          workflow?.data?.delivery_notice_apply?.complete && (
            <Button
              type="default"
              onClick={() => {
                handle('agree');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              批准
            </Button>
          )}
        {/* 退回送货申请 */}
        {self.isPurchase &&
          User.checkAuth('10030105') &&
          detail.status === 5 &&
          workflow?.data?.delivery_notice_apply?.complete && (
            <Button
              type="default"
              onClick={() => {
                handle('return1');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              退回送货申请
            </Button>
          )}
        {/* 退回送货 */}
        {self.isPurchase &&
          btnState.return &&
          User.checkAuth('10030108') &&
          [1, 13].includes(detail.status) &&
          detail.logisticsStatus > 0 &&
          detail.convertStatus < 1 && (
            <Button
              type="default"
              onClick={() => {
                handle('return2');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              退回
            </Button>
          )}

        {self.isPurchase &&
          btnState.return &&
          User.checkAuth('10030108') &&
          detail.status === 13 &&
          detail.logisticsStatus > 0 && (
            <Button
              type="default"
              onClick={() => {
                rejectApply();
              }}
              className="m-flex-item u-btn u-btn_warn"
            >
              拒绝申请
            </Button>
          )}

        {/* 转收货/入库 */}
        {self.isPurchase &&
          User.checkAuth('10030203') &&
          ((getButtonAuth('NEW_RECEIPT') &&
            isReceiving &&
            btnState.newReceive) ||
            (getButtonAuth('NEW_STORAGE_IN') &&
              isGodown &&
              btnState.newStorage)) && (
            <Button
              type="default"
              onClick={() => {
                changeDelivery(billType);
              }}
              className={[
                'm-flex-item',
                'u-btn',
                'u-btn_primary',
                !canGodown && billType !== 2 ? 'u-btn_gray' : '111'
              ].join(' ')}
            >
              {billType === 2 ? '转收货单' : '转入库单'}
            </Button>
          )}

        {/* 编辑送货数量或自定义字段 */}
        {((!self.isPurchase && [0, 4, 6].includes(detail.status)) ||
          (self.isPurchase && [1, 5].includes(detail.status))) && (
          <DeliveryItemsUpdate
            type="deliveryNotice"
            operateType={operateType}
            currItem={currItem}
            unitNum={decimalPlace}
            detail={detail}
            fieldSetting={fieldSetting}
            isPurchase={self.isPurchase}
            onChange={data => {
              if (data === 'success') {
                self.getDetail();
              }
            }}
          />
        )}

        {/* 送检 */}
        {User.checkAuth('10080102') &&
          detail.deliveryType !== 2 &&
          [1, 2, 3].includes(detail.status) &&
          detail.multiRelationRoleType !== 2 &&
          detail.canRreateIqcOrder &&
          [0, 1].includes(detail.sendVerifyStatus) &&
          detail.deliveryType !== 4 &&
          detail.inspectDelivey && (
            <Button
              type="default"
              onClick={() => {
                createIqcOrder();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              送检
            </Button>
          )}
      </div>
      {/* 转收货/入库组件 */}
      {companyCode && billType && (
        <DeliveryToReceive
          companyCode={companyCode}
          billType={billType}
          detail={detail}
          onChange={handleConvertChange}
        ></DeliveryToReceive>
      )}
      {/* 编辑物流信息 */}
      {!self.isPurchase && [0, 1, 4, 7].includes(detail.status) && (
        <Dialog
          anchor="bottom"
          open={logisticsEdit}
          classes={{ paper: props.classes.paper }}
          onClose={() => setLogisticsEdit(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">编辑物流信息</DialogTitle>
          <DialogContent>
            <ul>
              <li className="dialog order-detail-item">
                {/* 送货方式 编辑时隐藏送货方式中的 “直运指定地点”  */}
                <div className="line">
                  <span>送货方式</span>
                  <div>
                    {detail.directDeliveryFlag !== 1 &&
                      compEnum['B02_Logistics_Type'] && (
                        <FormControl
                          classes={{ marginNormal: props.classes.marginNormal }}
                          variant="outlined"
                          margin="normal"
                          fullWidth
                        >
                          <Select
                            value={detail.logisticsType || ''}
                            onChange={e =>
                              handleSelectChange(e, 'logisticsType')
                            }
                            input={
                              <OutlinedInput
                                labelWidth={0}
                                name="formTypeCode"
                                id="outlined-formTypeCode-simple"
                              />
                            }
                          >
                            {compEnum['B02_Logistics_Type'].map(
                              (item, index) => (
                                <MenuItem
                                  key={String(item.id) + index}
                                  value={item.id}
                                >
                                  {item.text}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                      )}
                    {detail.directDeliveryFlag === 1 && (
                      <span>{detail.logisticsTypeShow}</span>
                    )}
                  </div>
                </div>

                {/* 快递公司 */}
                {detail.logisticsType === 2 && (
                  <div className="line">
                    <span>快递公司</span>
                    <div>
                      <FormControl
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        classes={{ marginNormal: props.classes.marginNormal }}
                      >
                        <Select
                          value={detail.expressCompanyCode || ''}
                          onChange={e =>
                            handleSelectChange(e, 'expressCompanyCode')
                          }
                          input={
                            <OutlinedInput
                              labelWidth={0}
                              name="expressCompanyCode"
                              id="outlined-expressCompanyCode-simple"
                            />
                          }
                        >
                          {expressCompanyList.map((item, index) => (
                            <MenuItem
                              key={String(item.id) + index}
                              value={item.id}
                            >
                              {item.text}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                )}

                {/* 运输方式 */}
                <div className="line">
                  <span>运输方式</span>
                  <div>
                    {compEnumCustomer['B2b_Transport_Type_Code'] && (
                      <FormControl
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        classes={{ marginNormal: props.classes.marginNormal }}
                      >
                        <Select
                          value={detail.transportTypeCode || ''}
                          onChange={e =>
                            handleSelectChange(e, 'transportTypeCode')
                          }
                          input={
                            <OutlinedInput
                              labelWidth={0}
                              name="formTypeCode"
                              id="outlined-formTypeCode-simple"
                            />
                          }
                        >
                          {compEnumCustomer['B2b_Transport_Type_Code'].map(
                            (item, index) => (
                              <MenuItem
                                key={String(item.id) + index}
                                value={item.id}
                              >
                                {item.text}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    )}
                  </div>
                </div>
                {/* 送货车牌 */}
                {[1, 5].includes(detail.logisticsType) && (
                  <div className="line">
                    <span>送货车牌</span>
                    <div>
                      <input
                        type="text"
                        value={detail.deliveryCarNo || ''}
                        placeholder="录入送货车牌号码"
                        onChange={e => handleChange(e, 'deliveryCarNo')}
                        onBlur={e => handleBlur(e, 'deliveryCarNo')}
                      />
                    </div>
                  </div>
                )}
                {/* 送货联络 */}
                {[1, 5].includes(detail.logisticsType) && (
                  <div className="line">
                    <span>送货联络</span>
                    <div>
                      <input
                        type="text"
                        value={detail.contactPersion}
                        placeholder="司机姓名"
                        onChange={e => handleChange(e, 'contactPersion')}
                        onBlur={e => handleBlur(e, 'contactPersion')}
                      />
                      <input
                        style={{ marginTop: '5px' }}
                        type="text"
                        value={detail.contactMobile}
                        placeholder="司机手机"
                        onChange={e => handleChange(e, 'contactMobile')}
                        onBlur={e => handleBlur(e, 'contactMobile')}
                      />
                    </div>
                  </div>
                )}
                {/* 送货地址 */}
                <div className="line">
                  <span>
                    {detail.logisticsType === 3 ? '自提地址' : '送货地址'}
                  </span>
                  {detail.directDeliveryFlag !== 1 && (
                    <div>
                      {innerAddressList?.length > 0 && (
                        <FormControl
                          variant="outlined"
                          margin="normal"
                          classes={{ marginNormal: props.classes.marginNormal }}
                          fullWidth
                        >
                          <Select
                            value={detail.addressCode || ''}
                            onChange={e => handleSelectChange(e, 'addressCode')}
                            input={
                              <OutlinedInput
                                labelWidth={0}
                                name="formTypeCode"
                                id="outlined-formTypeCode-simple"
                              />
                            }
                          >
                            {innerAddressList.map((item, index) => (
                              <MenuItem
                                key={String(item.id) + index}
                                value={item.id}
                              >
                                {item.text}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                      {innerAddressList.length === 0 && (
                        <input
                          style={{ marginTop: '5px' }}
                          type="text"
                          value={detail.addressInfo}
                          onChange={e => handleChange(e, 'addressInfo')}
                          onBlur={e => handleBlur(e, 'addressInfo')}
                        />
                      )}
                    </div>
                  )}
                </div>
                {/* 联系方式 */}
                <div className="line">
                  <span>联系方式</span>
                  {innerAddressList.length === 0 && (
                    <div>
                      <input
                        type="text"
                        value={detail.receiveContactPerson}
                        onChange={e => handleChange(e, 'receiveContactPerson')}
                        onBlur={e => handleBlur(e, 'receiveContactPerson')}
                      />
                      <input
                        style={{ marginTop: '5px' }}
                        type="text"
                        value={detail.receiveContactWay}
                        onChange={e => handleChange(e, 'receiveContactWay')}
                        onBlur={e => handleBlur(e, 'receiveContactWay')}
                      />
                    </div>
                  )}
                  {innerAddressList.length !== 0 && (
                    <div>
                      {detail.receiveContactPerson && (
                        <span>{detail.receiveContactPerson},</span>
                      )}
                      {detail.receiveContactWay}
                    </div>
                  )}
                </div>
                {/* 物流单号 */}
                {[2].includes(detail.logisticsType) && (
                  <div className="line">
                    <span>物流单号</span>
                    <div>
                      <input
                        type="text"
                        value={detail.logisticsNumber}
                        placeholder="物流单号"
                        onChange={e => handleChange(e, 'logisticsNumber')}
                        onBlur={e => handleBlur(e, 'logisticsNumber')}
                      />
                    </div>
                  </div>
                )}
              </li>
            </ul>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleClose()}
              color="default"
              className="m-flex-item u-btn u-btn_primary"
            >
              取消
            </Button>

            <Button
              onClick={() => handleOk()}
              color="default"
              className="m-flex-item u-btn u-btn_primary"
            >
              确定
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Modal></Modal>
    </div>
  );
}

DeliveryDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DeliveryDetail));
